function Button(props: any) {
  const { onClick, variant, children, fullWidth, className, disabled } = props;
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={`button ${className ? className : ""} btn ${
        variant === "outlined" ? "btn-ghost" : ""
      } ${fullWidth ? "btn-fullwidth" : ""} ${disabled ? "btn-disabled" : ""}`}
    >
      {children}
    </button>
  );
}

export default Button;
